import React from 'react';
import { withTranslation } from 'react-i18next';

import './ycTrustUs.scss';

import { Add } from '@material-ui/icons';
import AnchorLink from 'react-anchor-link-smooth-scroll';

export const YcTrustUs = withTranslation()(
  class YcTrustUsClass extends React.PureComponent {

    importAll = (r) => {
      return r.keys().map(r);
    }

    images = this.importAll(
      require.context('../../assets/images/c-trust-us/', false, /\.(png|jpe?g|svg)$/)
    );

    render() {
      const { t } = this.props;
      return (
        <div className="yc-trust-us">
          <div className="row">
            <div className="col-xl-3 col-12 centered">
              <div className="content">
                <h2 dangerouslySetInnerHTML={{ __html: t('trust-us.title') }}></h2>

                <AnchorLink offset="0px" href="#contact-us" className="btn btn-primary d-block">
                  <Add />
                  <span>{t('trust-us.btn')}</span>
                </AnchorLink>
              </div>
            </div>
            <div className="col-xl-9 col-12 center-md">
              {this.images.map(img => (
                <img className="img" key={img} src={img} alt={t('trust-us.image')} />
              ))}
            </div>

          </div>
        </div>
      );
    }
  },
);
